// UI 크기(PC 설정 90% / 100% / 115%). HUD·창의 디자인 배율(designScale)에 곱한다. 기기 전용 저장(LOCAL_ONLY_KEYS).
// 폰·좁은 화면(가로 1000px 미만)에서는 적용하지 않는다: 이미 작은 화면에서 키우면 HUD가 서로 겹친다. 순수 판정은 uiSizeFactor, 저장·읽기는 아래.

export const UI_SIZE_KEY = 'dungeonhero.ui.size';
export const UI_SIZES: readonly number[] = [0.9, 1, 1.15];
/** 이 가로 폭 이상에서만 UI 크기 설정을 적용한다(PC·태블릿 가로) */
export const UI_SIZE_MIN_WIDTH = 1000;
export const UI_SIZE_EVENT = 'dh-ui-size';

export function parseUiSize(raw: string | null): number {
  if (!raw) return 1;
  const n = Number(raw);
  return UI_SIZES.includes(n) ? n : 1;
}

let memory: number | null = null;
export function loadUiSize(): number {
  if (memory !== null) return memory;
  try { memory = parseUiSize(typeof localStorage !== 'undefined' ? localStorage.getItem(UI_SIZE_KEY) : null); } catch { memory = 1; }
  return memory;
}
export function saveUiSize(n: number): number {
  memory = UI_SIZES.includes(n) ? n : 1;
  try { if (typeof localStorage !== 'undefined') localStorage.setItem(UI_SIZE_KEY, String(memory)); } catch { /* 저장 실패는 무시: 이번 접속은 유지 */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(UI_SIZE_EVENT, { detail: memory }));
  return memory;
}
/** 시험용 */
export function resetUiSizeMemory(): void { memory = null; }

/** 화면 폭에 맞는 실제 배율 계수(좁으면 1) */
export function uiSizeFactor(screenW: number, size: number = loadUiSize()): number {
  return screenW >= UI_SIZE_MIN_WIDTH ? size : 1;
}
